import React, { ReactElement, useEffect } from 'react';

import { useNavigate } from 'react-router';

import { ROLES } from '@/config/user';

function UnAuthGuard({ children, userInfo }): ReactElement {
  const navigate = useNavigate();

  useEffect(() => {
    if (!userInfo) return;
    const isGuest = userInfo.spRoles?.includes(ROLES.guest);
    navigate(isGuest ? '/new-service-partner' : '/systems', { replace: true });
  }, [userInfo, navigate]);

  // Don't render login page content for authenticated users — avoids flash before redirect
  if (userInfo) return null;

  return <>{children}</>;
}

export default UnAuthGuard;
